module.exports = __webpack_public_path__ + "static/img/newvideo.872633b5.png";